import {takeFirstDefinedForKeys} from 'powtoon-commons/utils'
import {getInitialWebVars} from 'powtoon-commons/utils/webvars'

const webvars = getInitialWebVars(({is_prod_env}) => is_prod_env)
const assignedWebVars = takeFirstDefinedForKeys({
  logzioId:                           [ webvars.logzio_id, '' ],
  logzioMetricsId:                    [ webvars.logzio_metrics_id, '' ],
  logzioUrl:                          [ webvars.logzio_url, 'https://listener.logz.io:8091' ],
  min_log_level:                      [ webvars.min_log_level, null ],
  appLevel:                           [ webvars.APP_LEVEL, null ],
  isProdEnv:                          [ webvars.is_prod_env, false ],
  pusherKey:                          [ process.env.PUSHER_KEY, webvars.pusher_key ],
  userId:                             [ webvars.user_id, null ],
  embeddedSessionId:                  [ webvars.embedded_session_id, null ],
  sessionId:                          [ webvars.session_id, webvars.embedded_session_id, null ],
  apiHost:                            [ process.env.API_HOST, webvars.api_host, '' ],
  cdnApiHost:                         [ webvars.CDN_API_HOST, '' ],
  contentPermissionId:                [ webvars.content_permission_id, 'CONTENT_PERMISSION_ID_IS_MISSING' ],
  enableUpgrades:                     [ webvars.enable_upgrades, true],
  pusherRegion:                       [ webvars.pusher_region ],
  licenseGeneration:                  [ webvars.license_generation, null],
  unauthMaxDailyProducerGenerations:  [ webvars.unauth_max_daily_producer_generations, '' ],
  minutesForProducerPermissionsCheck: [ webvars.minutes_for_producer_permissions_check, 10]
})

export default {
  getWebVars() {
    return assignedWebVars
  },

  getWebVar(propName: string) {
    return assignedWebVars[propName]
  }
}
